import { ScaleLinear } from 'd3-scale';
import {
    NumberFormat,
    postfixNumber,
    useDelayedHover,
} from '@instinet-analytics/core-lib';
import isNil from 'lodash/isNil';
import Tooltip from 'utils/components/Tooltip/Tooltip.tsx';
import classnames from 'classnames';
import React from 'react';
import classNames from 'classnames';

export function ChartLabels({
    averageVolume,
    yScale,
    width,
}: {
    averageVolume: number | undefined;
    numberFormat: NumberFormat;
    yScale: ScaleLinear<number, number>;
    height: number;
    width: number;
}) {
    const [onMouseEnter, onMouseLeave, showTypeLabel] = useDelayedHover(500);
    if (isNil(averageVolume)) {
        return <></>;
    }

    const labelWidth = showTypeLabel ? 117 : 35;
    const left = width - labelWidth + 20;
    const legendHeight = 18;
    const labelHeight = 17;
    const top = yScale(averageVolume) + legendHeight + labelHeight / 2;

    const cssClasses = classNames(
        'average-volume-label',
        showTypeLabel && 'show-type-label'
    );
    return (
        <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            // onClick={onClick}
            className={cssClasses}
            style={{
                top: top,
                left: left,
                width: labelWidth,
            }}
        >
            <div>
                <Tooltip text={'Average Volume'}>
                    {showTypeLabel && (
                        <div className="label">Average Volume</div>
                    )}
                    <div
                        className={classnames(
                            'value',
                            showTypeLabel && 'with-label'
                        )}
                    >
                        {postfixNumber(Math.round(averageVolume))}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
